"use strict";
/**
 * Review API Types
 *
 * Response types derived from ReviewRecord (shared-types/src/database/review.ts).
 * Request types remain standalone (Requirement 9).
 *
 * Derivation chain:
 *   ReviewRecord → SanitizedRecord<ReviewRecord> → Pick<..., fields> & ReviewExtension = ReviewResponse
 *
 * Consumed by: lambda-main, lambda-secure, free-pattern-warehouse-website
 */
Object.defineProperty(exports, "__esModule", { value: true });
